export { default } from './PrivateMainLayoutRoute'


// WEBPACK FOOTER //
// ./src/components/Router/PrivateMainLayoutRoute/index.js